import DesktopView from "@/pages/watch/desktopView/index"
import MobileTabView from "@/pages/watch/mobileTabView/index"
import NavBar from "@/components/video/navBar"
import { maxScreenWidthForDesktop } from "@/pages/watch/main/constants"
import { addCurrentThemeClassToEle } from "@/utils";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import "./style.css"

export default function WatchMainView(props: any) {
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className={`watchMainView0 ${addCurrentThemeClassToEle(currentTheme, 'watchMainView')}`}>
            <div className={`watchMainView  ${addCurrentThemeClassToEle(currentTheme, 'watchMainView')}`}>
                <NavBar />
                {props.isHydrated &&
                    <>
                        {props.screenWidth > 1280 ? (
                            <DesktopView
                                updateCurrentVideoObj={props.updateCurrentVideoObj}
                                isLoading={props.isLoading}
                                currentVideoObj={props.currentVideoObj}
                                seriesNotes={props.seriesNotes}
                                videoChangingId={props.videoChangingId}
                                playNextVideo={props.playNextVideo}
                                isWelcomeSeries={props.isWelcomeSeries}
                                seriesId={props.seriesId}
                                isSubscribedSeries={props.isSubscribedSeries}
                                isPGCourseSeries={props.isPGCourseSeries}
                            />
                        ) : (
                            <MobileTabView
                                updateCurrentVideoObj={props.updateCurrentVideoObj}
                                isLoading={props.isLoading}
                                currentVideoObj={props.currentVideoObj}
                                seriesNotes={props.seriesNotes}
                                playNextVideo={props.playNextVideo}
                                isWelcomeSeries={props.isWelcomeSeries}
                                seriesId={props.seriesId}
                                isSubscribedSeries={props.isSubscribedSeries}
                                isPGCourseSeries={props.isPGCourseSeries}
                            />
                        )}
                    </>
                }
            </div>
        </div>
    );
}
